'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _IconBase = require('./IconBase.js');

var _IconBase2 = _interopRequireDefault(_IconBase);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var PlotScatterpolarIcon = function PlotScatterpolarIcon(props) {
    return _react2.default.createElement(
        _IconBase2.default,
        _extends({ viewBox: '0 0 32 32' }, props),
        _react2.default.createElement('path', { d: 'M28.438 15.188l-.563-6.938c1.063-1.063 1.313-2.75.625-4.125-.625-1.375-2.063-2.188-3.625-2.063-1.5.125-2.813 1.188-3.188 2.688l-3.438.125c-.938-1.5-2.75-2.188-4.438-1.563-1.688.563-2.688 2.313-2.375 4.063l-4.375 1.75C5.873 8 4.123 7.75 2.748 8.5a3.647 3.647 0 0 0-1.875 3.938c.25 1.563 1.563 2.75 3.125 3l2 6.938c-1 .938-1.313 2.313-.938 3.625s1.438 2.25 2.75 2.563c1.313.25 2.688-.188 3.563-1.188l5.125.875c.938 1.438 2.688 2.063 4.313 1.5s2.688-2.188 2.438-3.938l3.625-3.438c1.938.375 3.875-.938 4.25-2.875.438-1.938-.75-3.875-2.688-4.313zm-3.375 6.25l-2.625 2.5c-.938-1.188-2.563-1.625-4-1.125-1.5.5-2.5 1.813-2.5 3.375l-3.75-.625a3.65 3.65 0 0 0-1.125-3.25c-.938-.875-2.188-1.188-3.375-.875l-1.75-6.313c1.688-.688 2.563-2.563 2.063-4.313l4.25-1.688a3.725 3.725 0 0 0 4.063 1.125c1.5-.563 2.438-1.938 2.438-3.5l2.875-.063c.5 1.875 2.438 3.063 4.375 2.625l.5 5.875c-1.313.375-2.25 1.438-2.563 2.75-.313 1.25.125 2.625 1.125 3.5z' })
    );
};

exports.default = PlotScatterpolarIcon;


//////////////////
// WEBPACK FOOTER
// ./node_modules/plotly-icons/lib/components/PlotScatterpolarIcon.js
// module id = 686
// module chunks = 0